import Events from './events'

export const amplitudeEvents = Events

// Amplitude отключена: SDK не подключается, вызовы ничего не отправляют
export function amplitudeInitialize () {}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const amplitudeLogEvent = (event: Events, options?: any) => {}
